import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Lukas S.',
  city: 'Zürich',
  role: 'Junglehrer',
  text: 'Als Junglehrerin war dieses System meine Rettung. Keine Rätselraten mehr bei der Semesterplanung. Ich habe in der ersten Woche 8 Stunden gespart.'
}, {
  name: 'Sarah M.',
  city: 'Basel',
  role: '12 Jahre Erfahrung',
  text: 'Endlich Schweizer Fälle, die meine Schüler wirklich motivieren. Das OR-Modul ist das Beste, was ich je in einem Lehrwerk gesehen habe.'
}, {
  name: 'Marc K.',
  city: 'Luzern',
  role: 'Gymnasium Lehrer',
  text: 'Herunterladen, ausdrucken, unterrichten. Mehr braucht es nicht. Die Zeitersparnis ist enorm. Meine Sonntage gehören wieder mir.'
}, {
  name: 'Julia F.',
  city: 'Bern',
  role: 'Berufsmaturität',
  text: 'Die Strukturierung nach Lehrplan 21 ist perfekt umgesetzt. Besonders die Fallstudien im Experten-System sind Gold wert für die Prüfungsvorbereitung.'
}, {
  name: 'Thomas W.',
  city: 'St. Gallen',
  role: 'Kantonsschule',
  text: 'Das beste Material für Wirtschaft und Recht, das ich in 15 Jahren gesehen habe. Die Schüler arbeiten viel selbstständiger mit den klaren Arbeitsblättern.'
}];
export function Testimonials() {
  return <section className="py-12 px-4 bg-swiss-card-bg border-y border-gray-200" data-id="element-182">
      <div className="max-w-2xl mx-auto" data-id="element-183">
        <div className="space-y-4" data-id="element-184">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-gray-200 p-5 rounded-xl shadow-sm" data-id="element-185">
              <div className="flex text-swiss-gold mb-3" data-id="element-186">
                {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-187" />)}
              </div>
              <p className="text-gray-700 font-medium italic mb-4 text-sm sm:text-base" data-id="element-188">
                "{t.text}"
              </p>
              <div className="border-t border-gray-100 pt-3" data-id="element-189">
                <div className="font-bold text-swiss-charcoal text-sm" data-id="element-190">
                  {t.name} | {t.city}
                </div>
                <div className="text-xs text-gray-500" data-id="element-191">{t.role}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}